import React from 'react';

const PlatformTableSkeleton = () => {
  const numberOfRows = 2;
  // Configuración de 10 columnas: Plataforma, Gasto Total, Conversiones, CPA, ROAS, Clicks, CPC, Impresiones, CPM, CTR
  const columnsConfig = [
    { headerAlignment: 'text-left', headerWidth: 'w-24', bodyWidth: 'w-20', bodyHeight: 'h-4', isFirstColumn: true },
    { headerAlignment: 'text-center', headerWidth: 'w-24', bodyWidth: 'w-20', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-24', bodyWidth: 'w-16', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-16', bodyWidth: 'w-16', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-16', bodyWidth: 'w-16', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-12', bodyWidth: 'w-16', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-20', bodyWidth: 'w-20', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-12', bodyWidth: 'w-16', bodyHeight: 'h-4', isFirstColumn: false },
    { headerAlignment: 'text-center', headerWidth: 'w-12', bodyWidth: 'w-12', bodyHeight: 'h-4', isFirstColumn: false }
  ];

  // Configuración específica para la primera columna de cada fila (Google Ads, Meta Ads)
  const firstColumnConfigs = [
    { iconWidth: 'w-6', textWidth: 'w-20' }, // Google Ads
    { iconWidth: 'w-6', textWidth: 'w-16' }  // Meta Ads
  ];

  return (
    <div className="backdrop-blur-xl bg-gradient-to-br from-slate-800/90 via-slate-900/90 to-indigo-900/90 border border-white/20 rounded-2xl p-4 sm:p-6 shadow-lg hover:shadow-xl hover:bg-gradient-to-br hover:from-slate-700/90 hover:via-slate-800/90 hover:to-indigo-800/90 hover:border-white/30 hover:scale-[1.02] transition-all duration-500 ease-out mt-8 sm:mt-12">
      <div className="relative z-10">
        <div className="overflow-x-auto rounded-lg">
          <table className="w-full min-w-[700px]">
            <thead>
              <tr className="border-b border-white/30">
                {columnsConfig.map((column, index) => (
                  <th key={index} className={`${column.headerAlignment} py-3 px-4`}>
                    <div className={`h-4 ${column.headerWidth} bg-white/20 rounded animate-pulse ${column.headerAlignment === 'text-center' ? 'mx-auto' : ''}`}></div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="divide-y divide-white/20">
              {[...Array(numberOfRows)].map((_, rowIndex) => (
                <tr key={rowIndex} className="hover:bg-white/10 transition-colors">
                  {columnsConfig.map((column, colIndex) => (
                    <td key={colIndex} className={`py-4 px-4 ${column.isFirstColumn ? 'text-left' : 'text-center'}`}>
                      {column.isFirstColumn ? (
                        <div className="flex items-center gap-2">
                          <div className={`h-6 ${firstColumnConfigs[rowIndex].iconWidth} bg-white/20 rounded animate-pulse`}></div>
                          <div className={`h-4 ${firstColumnConfigs[rowIndex].textWidth} bg-white/20 rounded animate-pulse`}></div>
                        </div>
                      ) : (
                        <div className={`${column.bodyHeight} ${column.bodyWidth} bg-white/20 rounded animate-pulse mx-auto`}></div>
                      )}
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default PlatformTableSkeleton;
